const Mixin = {
  methods: {
  },
  computed: {
    logo() {
      return require(`@/assets/${process.env.VUE_APP_LOGO_PATH}`);
    },
  },
};

export default Mixin;
